var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.8501C12 11.8501 13.55 8.82007 13.94 7.85007C13.71 7.28007 13.07 5.99007 11.78 5.03007L12.49 4.32007C14.38 5.80007 15 7.85007 15 7.85007C15 7.85007 13.5 12.8501 8 12.8501C6.68 12.8501 5.59 12.5601 4.69 12.1201L5.44 11.3701C6.15 11.6701 7 11.8601 8 11.8601V11.8501Z",
    stroke: "none",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.8501C1 7.8501 2.5 2.8501 8 2.8501C9.49 2.8501 10.68 3.2201 11.63 3.7601L10.89 4.5001C10.11 4.1101 9.16 3.8501 8 3.8501C4 3.8501 2.45001 6.8801 2.06001 7.8501C2.31001 8.4601 3.02001 9.9001 4.52001 10.8701L3.8 11.5901C1.68001 10.1101 1 7.8501 1 7.8501Z",
    stroke: "none",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.8501C6.9 5.8501 6 6.7501 6 7.8501C6 8.2801 6.14 8.6801 6.38 9.0101L5.67 9.7201C5.26 9.2101 5 8.5601 5 7.8501C5 6.1901 6.34 4.8501 8 4.8501C8.71 4.8501 9.36 5.1101 9.87 5.5201L9.16 6.2301C8.83 5.9901 8.43 5.8501 8 5.8501Z",
    stroke: "none",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 10.85C7.41999 10.85 6.87999 10.68 6.41999 10.39L7.14999 9.66003C7.40999 9.78003 7.68999 9.86003 7.99999 9.86003C9.09999 9.86003 9.99999 8.96003 9.99999 7.86003C9.99999 7.56003 9.92999 7.27003 9.79999 7.01003L10.53 6.28003C10.82 6.74003 10.99 7.28003 10.99 7.86003C10.99 9.52003 9.64999 10.86 7.98999 10.86L7.99999 10.85Z",
    stroke: "none",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.935 1.8501L1.935 12.8501",
    stroke: "current",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDisable);
export default __webpack_public_path__ + "static/media/eye-disable.a4cb34391b70fe06076b441d23abcc1b.svg";
export { ForwardRef as ReactComponent };